import React, { useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed'
import AOS from 'aos';

import Header from '../../components/Header';
import Footer from '../../components/Footer';


import './styles.css';
import './../../assets/styles/globals.css';

function Windfarm(props) {
  const windfarm = props.location.state.windfarm
  const images = [
    {
      original: process.env.PUBLIC_URL.slice(0, -1) + windfarm.Images[0],
      thumbnail: process.env.PUBLIC_URL.slice(0, -1) + windfarm.Images[0],
    },
    {
      original: process.env.PUBLIC_URL.slice(0, -1) + windfarm.Images[1],
      thumbnail: process.env.PUBLIC_URL.slice(0, -1) + windfarm.Images[1],
    },
    {
      original: process.env.PUBLIC_URL.slice(0, -1) + windfarm.Images[2],
      thumbnail: process.env.PUBLIC_URL.slice(0, -1) + windfarm.Images[2],
    },
    {
      original: process.env.PUBLIC_URL.slice(0, -1) + windfarm.Images[3],
      thumbnail: process.env.PUBLIC_URL.slice(0, -1) + windfarm.Images[3],
    },
  ];
  useEffect(() => {
    AOS.init()
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])
  return (
    windfarm ?
      <>
        <Header />
        <div className="background-about-us">
          <div className="bg-about-us"></div>
          <div className="container" data-aos-once="true" data-aos="zoom-in" data-aos-duration="1000">
            <div className="banner-windfarm content-windfarm">
              <h1>{windfarm.Project}</h1>
              <p>{windfarm.State}</p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="gap-windfarm" data-aos-once="true" data-aos="fade-in" data-aos-duration="1000">
            <Row>
              <Col xs={12} md={7} sm={6} lg={7} >
                <div className="windfarm-basic-info">
                  <p>
                    Alegria wind farm (151.8 MW) is the largest wind project under the PROINFA program in Brazil. <br></br>The wind farm is located in a 10km sandy coastal area in the state of Rio Grande do Norte. The wind farm is able to produce electricity for a population of 1 million people.
                </p>
                </div>
              </Col>
              <Col xs={12} md={5} sm={6} lg={5}>
                <table className="windfarm-table">
                  <tbody>
                    <tr>
                      <td>Number of turbines</td>
                      <td>{windfarm.Turbines}</td>
                    </tr>
                    <tr>
                      <td>Total Capacity</td>
                      <td>{windfarm.MW}</td>
                    </tr>
                    <tr>
                      <td>Location</td>
                      <td>{windfarm.Location}</td>
                    </tr>
                    <tr>
                      <td>Transmission Line</td>
                      <td>{windfarm.Transmission}</td>
                    </tr>
                    <tr>
                      <td>Turbine Manufacturer</td>
                      <td>{windfarm.Supplier}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
        </div>

        <div className="container">
          <div className="content section-photos">
            <h1 data-aos-once="true" data-aos="slide-up" data-aos-duration="1000">Photos</h1>
            <div className="windfarm-photos" data-aos-once="true" data-aos="fade-in" data-aos-duration="1000">
              <div>
                <Row>
                  <ImageGallery items={images} />
                </Row>
              </div>
            </div>
          </div>
        </div>

        {
          windfarm.Video ? 
            <div className="container">
              <div className="content section-photos">
                <h1 data-aos-once="true" data-aos="slide-up" data-aos-duration="1000">Videos</h1>
                <div className="windfarm-photos">
                  <Row>
                    <Col md={12} lg={12} data-aos-once="true" data-aos="slide-right" data-aos-duration="1000">
                      <div style={{ width: '56vw', height: 'auto' }}>
                        <ResponsiveEmbed aspectRatio="16by9">
                          <iframe title="Windfarm's Video" src={windfarm.Video} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" ></iframe>
                        </ResponsiveEmbed>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div> : null 
        }
        <Footer />
      </> : <Redirect to="/onshore" />
  )
}

export default Windfarm;